var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20711 5.79289C6.81658 5.40237 6.18342 5.40237 5.79289 5.79289C5.40237 6.18342 5.40237 6.81658 5.79289 7.20711L10.5858 12L5.79289 16.7929C5.40237 17.1834 5.40237 17.8166 5.79289 18.2071C6.18342 18.5976 6.81658 18.5976 7.20711 18.2071L12 13.4142L16.7929 18.2071C17.1834 18.5976 17.8166 18.5976 18.2071 18.2071C18.5976 17.8166 18.5976 17.1834 18.2071 16.7929L13.4142 12L18.2071 7.20711C18.5976 6.81658 18.5976 6.18342 18.2071 5.79289C17.8166 5.40237 17.1834 5.40237 16.7929 5.79289L12 10.5858L7.20711 5.79289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineXMark);
export default __webpack_public_path__ + "static/media/line-x-mark.b2922e718cca6a9b2ab3c15d9f8e450f.svg";
export { ForwardRef as ReactComponent };